import React, { useState, useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import {
  sendOTP,
  authenticateOTP,
  getCustomerInfo,
  checkForDuplicateEmail,
  registerCustomer,
} from "../../../adapters/auth/Login";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { updateToLogin } from "../../../redux/reducers/user_info/userInfoReducer";
import { Spinner } from "reactstrap";
import {
  getClientTimezone,
  submitEstimateCallBackRequest,
  updateOrderData,
} from "../../../adapters/estimate/estimateAdapters";
import navigationsLinks, {
  BOXIGO_WEBSITE_LINKS,
} from "../../../constants/navigation_links";
import { thunkClearEstimateData } from "../../../redux/reducers/progress/progressReducer";
import { thunkSubmitMoveInfoForm } from "../../../redux/reducers/move_info/moveInfoReducer";
import { thunkSubmitMoveInfoForm as thunkSubmitStorageMoveInfoForm } from "../../../redux/reducers/storage_moveinfo/moveInfoReducer";
// import moment from "moment";
import momentTimeZone from "moment-timezone";
import config from "../../../config/config";
import { verifyOrderInDB } from "../../../functions/helper";
export default function LoginModal(props) {
  const { register, errors, handleSubmit, getValues } = useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const { isSkipInventory } = props;
  // const {estimateSubmitType} = props;
  // const isLoggedIn = useSelector((state) => state.userInfo.loggedIn);

  const [isOTPsent, setIsOTPsent] = useState(false);
  // const [isOTP_resent, setIsOTP_resent] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);
  const [timerCount, setTimerCount] = useState(30);
  const [timerStatus, setTimerStatus] = useState(false);
  const [submitProgress, setSubmitProgress] = useState(false);
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState({ status: false, message: "" });

  const [statusMessage, setStatusMessage] = useState("");
  const moveInfo = useSelector((state) => state.moveInfo);
  const propertyInfo = useSelector((state) => state.propertyInfo);
  // const inventoryInfo = useSelector((state) => state.inventoryInfo);

  const onSubmit = async (data) => {
    //1. Send OTP.
    //2. AuthOTP and phone and login.
    //3. if new user insert and login.

    if (isOTPsent === false) {
      handleSendOTP(data);
    } else if (isOTPsent === true && isNewUser === false) {
      handleLoginAuth(data);
    } else if (isNewUser === true) {
      handleNewUserLogin(data);
    }
  };

  const handleLoginAuth = async (data) => {
    //clientTimezone
    const body = {
      emailId: null,
      mobile: data["phone"],
      otp: data["otp"],
      password: null,
      loginType: "mobile",
    };

    setStatusMessage("Verifying OTP, Please wait...");
    try {
      const response = await authenticateOTP(body);
      console.log(response);

      if (response.status === 200) {
        try {
          const customerData = await getCustomerInfo(data["phone"]);
          // console.log(customerData);
          if (
            customerData["data"]["meta"]["code"] === 200 &&
            customerData["data"]["meta"]["status"] === "OK"
          ) {
            const data = customerData["data"]["data"][0];
            setIsOTPsent(true);
            setStatusMessage("OTP is verified, Please wait...");
            const userInfoSession = {
              loggedIn: true,
              email: data["email"],
              customerName: data["first_name"],
              isEmailVerified: data["is_email_verified"],
              isPhoneVerified: data["is_phone_verified"],
              userId: data["user_id"],
              phone: data["phone"],
            };

            sessionStorage.setItem(
              "userSessionData",
              JSON.stringify(userInfoSession)
            );

            const reduxPayload = {
              ...userInfoSession,
              history,
            };
            // dispatch(thunkLoginUser(reduxPayload));
            dispatch(updateToLogin(reduxPayload));
            if (props.serviceType === "storage") {
              dispatch(thunkSubmitStorageMoveInfoForm(props.moveInfoData));
            } else {
              dispatch(thunkSubmitMoveInfoForm(props.moveInfoData));
            }
            //save data to backend
            // collectLeadDetails();
            // history.push(navigationsLinks.property_info_page);
            //move to the next page
            // history.push

            // props.referenceToSubmit();
            // if (isSkipInventory === true) {
            //   handleSkipInventorySubmit();
            // } else {
            //   handleEstimateSubmit();
            // }
          } else {
            setStatusMessage("An Error occurred, Please try again later.");
          }
        } catch (error) {
          // console.log(error.response.data);
          if (
            error.response.data.meta.code === 404 &&
            error.response.data.meta.status === "failed"
          ) {
            //create an customer
            setIsNewUser(true);
            setStatusMessage("");
            return;
          } else {
            setStatusMessage("An Error occurred, Please try again later.");
          }
        }
      } else {
        setStatusMessage("An Error occurred, Please try again later.");
      }
    } catch (e) {
      console.error("error occurred", e);
      setStatusMessage("An Error occurred, Please try again later.");
    }
  };

  const handleSendOTP = async (data) => {
    setStatusMessage("Sending OTP..");
    try {
      const response = await sendOTP(data["phone"]);
      if (response.status === 200) {
        setIsOTPsent(true);
        setTimerStatus(true);
        setStatusMessage("OTP is sent to your number.");
      } else {
        setStatusMessage("An Error occurred, Please try again later.");
      }
    } catch (e) {
      console.error("error occurred", e);
      setStatusMessage("An Error occurred, Please try again later.");
    }
  };
  const resendOTP = async () => {
    const phone = getValues("phone");
    setStatusMessage("Sending OTP..");
    try {
      const response = await sendOTP(phone);
      if (response.status === 200) {
        // setIsOTP_resent(true);
        setTimerStatus(true);
        setStatusMessage("OTP is sent to your number.");
      } else {
        setStatusMessage("An Error occurred, Please try again later.");
      }
    } catch (e) {
      console.error("error occurred", e);
      setStatusMessage("An Error occurred, Please try again later.");
    }
  };

  const handleNewUserLogin = async (data) => {
    setStatusMessage("Processing...");
    try {
      let response = await checkForDuplicateEmail(data["email"]);
      if (response.status === 200) {
        // setIsOTP_resent(true);
        setTimerStatus(true);
        setStatusMessage("Email Already exists.");
      }
    } catch (error) {
      if (error.response.data) {
        if (error.response.data.meta.code === 404) {
          let body = {
            phone: data["phone"],
            first_name: data["fullName"],
            last_name: "",
            email: data["email"],
          };
          try {
            let response = await registerCustomer(body);
            if (
              response["data"]["meta"]["code"] === "200" &&
              response["data"]["meta"]["status"] === "OK"
            ) {
              setStatusMessage("Registered successfully, Logging in...");
              const data = response["data"]["data"];
              setIsOTPsent(true);
              setStatusMessage("OTP is verified, Logging in...");
              const userInfoSession = {
                loggedIn: true,
                email: data["email"],
                customerName: data["first_name"],
                isEmailVerified: "0",
                isPhoneVerified: "0",
                userId: data["user_id"],
                phone: data["phone"],
              };

              sessionStorage.setItem(
                "userSessionData",
                JSON.stringify(userInfoSession)
              );

              const reduxPayload = {
                ...userInfoSession,
                history,
              };
              dispatch(updateToLogin(reduxPayload));
              if (props.serviceType === "storage") {
                dispatch(thunkSubmitStorageMoveInfoForm(props.moveInfoData));
              } else {
                dispatch(thunkSubmitMoveInfoForm(props.moveInfoData));
              }

              // if (isSkipInventory === true) {
              //   handleSkipInventorySubmit();
              // } else {
              //   handleEstimateSubmit();
              // }
            } else {
              setStatusMessage("An Error occurred, Please try again later.");
            }
          } catch (error) {
            console.log(error);
            setStatusMessage("An Error occurred, Please try again later.");
          }
        }
      } else {
        setStatusMessage("An Error occurred, Please try again later.");
      }
    }
  };
  const getFlexibleStatus = (isFlexible) => {
    return isFlexible === true ? 1 : 0;
  };

  const handleEstimateSubmit = async (e) => {
    const isOrderOutdated = await verifyOrderInDB("relocation");
    if (isOrderOutdated === true) {
      dispatch(thunkClearEstimateData());
      history.push("/");
      return;
    }
    const userSessionData = JSON.parse(
      sessionStorage.getItem("userSessionData")
    );
    const orderDetails = JSON.parse(sessionStorage.getItem("orderDetails"));
    const estimate_id = orderDetails.orderId;
    const userId = userSessionData.userId;
    const additionalInfo = props.additionalInfo;
    const params = {
      additional_info: additionalInfo,
      user_id: userId,
      estimate_id: estimate_id,
      update_type: "additional_info",
      lead_stage: "payment_initiated",
    };

    try {
      const response = await updateOrderData(params);
      if (response.data.code === 200) {
        dispatch(thunkClearEstimateData({ history }));
        history.push(`${navigationsLinks.confirmation_page}/relocation/${estimate_id}`);
        // setSubmitProgress(false);
      }
    } catch (e) {
      console.error(e);
      setSubmitProgress(false);
      setError({
        status: true,
        message: "OOP's! An Error Occurred, Please try again later.",
      });
    }
    return;
    // complete order create code
    // setSubmitProgress(true);
    // const userSessionData = JSON.parse(
    //   sessionStorage.getItem("userSessionData")
    // );

    // const userId = userSessionData.userId;
    // const customerName = userSessionData.customerName;
    // const itemsJSON = JSON.stringify(inventoryInfo.toJS());
    // const additionalInfo = props.additionalInfo;
    // const totalItemsCount = getTotalItemsCount(inventoryInfo);

    // const clientTimezone = getClientTimezone();

    // let movingDate =
    //   moveInfo.moveType === "Within City"
    //     ? new Date(moveInfo.withinCityMovingOnDate)
    //     : new Date(moveInfo.interCityMovingOnDate);
    // movingDate = momentTimeZone
    //   .tz(movingDate, "UTC")
    //   .format("YYYY-MM-DD HH:mm:ss");
    // const fromAddress = {
    //   firstName: customerName,
    //   lastName: "",
    //   fromAddress: propertyInfo.oldHouseAddress,
    //   fromLocality: propertyInfo.oldHouseLocation,
    //   fromCity: propertyInfo.oldHouseCity,
    //   fromState: propertyInfo.oldHouseState,
    //   pincode: propertyInfo.oldHousePincode,
    // };

    // const toAddress = {
    //   firstName: customerName,
    //   lastName: "",
    //   toAddress: propertyInfo.newHouseAddress,
    //   toLocality: propertyInfo.newHouseLocation,
    //   toCity: propertyInfo.newHouseCity,
    //   toState: propertyInfo.newHouseState,
    //   pincode: propertyInfo.newHousePincode,
    // };
    // const body = {
    //   user_id: userId,
    //   city_type: moveInfo.moveType.toLowerCase(),
    //   select_city: moveInfo.selectCity,
    //   moving_from:
    //     moveInfo.moveType === "Within City"
    //       ? moveInfo.withinCityMovingFrom
    //       : moveInfo.interCityMovingFrom,
    //   moving_to:
    //     moveInfo.moveType === "Within City"
    //       ? moveInfo.withinCityMovingTo
    //       : moveInfo.interCityMovingTo,
    //   moving_on: movingDate,
    //   distance:
    //     moveInfo.moveType === "Within City"
    //       ? moveInfo.withinCityDistance
    //       : moveInfo.interCityDistance,
    //   duration:
    //     moveInfo.moveType === "Within City"
    //       ? moveInfo.withinCityDuration
    //       : moveInfo.interCityDuration,
    //   property_size:
    //     moveInfo.moveType === "Within City"
    //       ? moveInfo.withinCityPropertySize
    //       : moveInfo.interCityPropertySize,
    //   move_date_flexible:
    //     moveInfo.moveType === "Within City"
    //       ? getFlexibleStatus(moveInfo.withinCityhasFlexibleDate)
    //       : getFlexibleStatus(moveInfo.interCityhasFlexibleDate),
    //   old_floor_no: parseInt(propertyInfo.oldFloorNumber),
    //   new_floor_no: parseInt(propertyInfo.newFloorNumber),
    //   old_elevator_availability: propertyInfo.oldHouseHasElevator,
    //   packing_service: "Yes",
    //   new_elevator_availability: propertyInfo.newHouseHasElevator,
    //   unpacking_service: "No",
    //   old_parking_distance:
    //     Math.floor(propertyInfo.oldHouseDistance) +
    //     " " +
    //     propertyInfo.oldHouseDistanceUnit,
    //   new_parking_distance:
    //     Math.floor(propertyInfo.newHouseDistance) +
    //     " " +
    //     propertyInfo.newHouseDistanceUnit,
    //   old_house_additional_info: additionalInfo,
    //   new_house_additional_info: "",
    //   items: itemsJSON,
    //   total_items: totalItemsCount,
    //   call_back: 0,
    //   service_type: "relocation",
    //   client_timezone: clientTimezone, // get client timezone
    //   from_address: JSON.stringify(fromAddress),
    //   to_address: JSON.stringify(toAddress),
    //   created_by: "customer",
    // };
    // const params = body;
    // try {
    //   const response = await submitEstimate(params);
    //   if (
    //     response.data.meta.code === 200 &&
    //     response.data.meta.status === "OK"
    //   ) {
    //     const estimateId = response.data.data.estimate_id;
    //     dispatch(thunkClearEstimateData({ history }));
    //     history.push(navigationsLinks.confirmation_page + "/" + estimateId);
    //     // setSubmitProgress(false);
    //   }
    // } catch (e) {
    //   console.error(e);
    //   setSubmitProgress(false);
    //   setError({
    //     status: true,
    //     message: "OOP's! An Error Occurred, Please try again later.",
    //   });
    // }
  };
  const handleSkipInventorySubmit = async (e) => {
    alert("skip data handle");
    setSubmitProgress(true);
    const userSessionData = JSON.parse(
      sessionStorage.getItem("userSessionData")
    );
    const userId = userSessionData.userId;
    const customerName = userSessionData.customerName;

    const clientTimezone = getClientTimezone();

    let movingDate =
      moveInfo.moveType === "Within City"
        ? new Date(moveInfo.withinCityMovingOnDate)
        : new Date(moveInfo.interCityMovingOnDate);
    movingDate = momentTimeZone
      .tz(movingDate, "UTC")
      .format("YYYY-MM-DD HH:mm:ss");

    // const local = moment(new Date(moveInfo.withinCityMovingOnDate)).format("YYYY-MM-DD HH:mm:ss");
    // const utc = movingDate;
    const fromAddress = {
      firstName: customerName,
      lastName: "",
      fromAddress: propertyInfo.oldHouseAddress,
      fromLocality: propertyInfo.oldHouseLocation,
      fromCity: propertyInfo.oldHouseCity,
      fromState: propertyInfo.oldHouseState,
      pincode: propertyInfo.oldHousePincode,
    };

    const toAddress = {
      firstName: customerName,
      lastName: "",
      toAddress: propertyInfo.newHouseAddress,
      toLocality: propertyInfo.newHouseLocation,
      toCity: propertyInfo.newHouseCity,
      toState: propertyInfo.newHouseState,
      pincode: propertyInfo.newHousePincode,
    };
    const body = {
      user_id: userId,
      city_type: moveInfo.moveType.toLowerCase(),
      select_city: moveInfo.selectCity,
      moving_from:
        moveInfo.moveType === "Within City"
          ? moveInfo.withinCityMovingFrom
          : moveInfo.interCityMovingFrom,
      moving_to:
        moveInfo.moveType === "Within City"
          ? moveInfo.withinCityMovingTo
          : moveInfo.interCityMovingTo,
      moving_on: movingDate,
      distance:
        moveInfo.moveType === "Within City"
          ? moveInfo.withinCityDistance
          : moveInfo.interCityDistance,
      duration:
        moveInfo.moveType === "Within City"
          ? moveInfo.withinCityDuration
          : moveInfo.interCityDuration,
      property_size:
        moveInfo.moveType === "Within City"
          ? moveInfo.withinCityPropertySize
          : moveInfo.interCityPropertySize,
      move_date_flexible:
        moveInfo.moveType === "Within City"
          ? getFlexibleStatus(moveInfo.withinCityhasFlexibleDate)
          : getFlexibleStatus(moveInfo.interCityhasFlexibleDate),
      old_floor_no: parseInt(propertyInfo.oldFloorNumber),
      new_floor_no: parseInt(propertyInfo.newFloorNumber),
      old_elevator_availability: propertyInfo.oldHouseHasElevator,
      packing_service: "Yes",
      new_elevator_availability: propertyInfo.newHouseHasElevator,
      unpacking_service: "No",
      old_parking_distance:
        Math.floor(propertyInfo.oldHouseDistance) +
        " " +
        propertyInfo.oldHouseDistanceUnit,
      new_parking_distance:
        Math.floor(propertyInfo.newHouseDistance) +
        " " +
        propertyInfo.newHouseDistanceUnit,
      new_house_additional_info: "",
      old_house_additional_info: "",
      items: "null",
      total_items: "1",
      call_back: 1,
      service_type: "none",
      client_timezone: clientTimezone, // get client timezone
      additional_info: "",
      from_address: JSON.stringify(fromAddress),
      to_address: JSON.stringify(toAddress),
      created_by: "customer",
      update_type: "callback",
    };

    const params = body;
    try {
      const response = await submitEstimateCallBackRequest(params);
      console.log(response);
      if (
        response.data.meta.code === 200 &&
        response.data.meta.status === "OK"
      ) {
        const estimateId = response.data.data.estimate_id;
        dispatch(thunkClearEstimateData({ history }));
        history.push(
          navigationsLinks.skip_confirmation_page + "/" + estimateId
        );
      }
    } catch (e) {
      setSubmitProgress(false);
      setError({
        status: true,
        message: "OOP's an Error occurred, Please try again later.",
      });
      console.error(e);
    }
  };
  // memoize function to prevent additional re-renders.
  const skipSubmitCallBack = useCallback(handleSkipInventorySubmit, []);
  const estimateFlowSubmit = useCallback(handleEstimateSubmit, []);
  useEffect(() => {
    if (props.isOpen === true) {
      const userSessionData = sessionStorage.getItem("userSessionData");
      if (userSessionData !== null) {
        if (isSkipInventory === true) {
          skipSubmitCallBack();
        } else {
          estimateFlowSubmit();
        }
      }
    }
  }, [skipSubmitCallBack, props.isOpen, estimateFlowSubmit, isSkipInventory]);

  useEffect(() => {
    let timerInterval = null;
    if (timerStatus === true) {
      timerInterval = setInterval(() => {
        setTimerCount((prevousCount) => prevousCount - 1);
      }, 1000);
    } else {
      setTimerCount(30);
      clearInterval(timerInterval);
    }
    return () => {
      setTimerCount(30);
      clearInterval(timerInterval);
    };
  }, [timerStatus]);

  useEffect(() => {
    if (timerCount === 0) {
      setTimerStatus(false);
      setTimerCount(30);
    }
  }, [timerCount]);
  const relocationServicesList = [
    {
      id: 1,
      label: "Lowest Price Guaranteed",
      img: `${config.customerPortal}/assets/images/estimate_flow/icons/down-arrow.png`,
    },
    {
      id: 2,
      label: "5 Star Rated Service",
      img: `${config.customerPortal}/assets/images/estimate_flow/icons/star.png`,
    },
    {
      id: 3,
      label: "Insurance Coverage",
      img: `${config.customerPortal}/assets/images/estimate_flow/icons/insurance.png`,
    },
    {
      id: 4,
      label: "Pest & Fire Control",
      img: `${config.customerPortal}/assets/images/estimate_flow/icons/pest-control.png`,
    },
  ];
  const storageServicesList = [
    {
      id: 1,
      label: "Lowest Price Guaranteed",
      img: `${config.customerPortal}/assets/images/estimate_flow/icons/down-arrow.png`,
    },
    {
      id: 2,
      label: "5 Star Rated Service",
      img: `${config.customerPortal}/assets/images/estimate_flow/icons/star.png`,
    },
    {
      id: 3,
      label: "Insurance Coverage",
      img: `${config.customerPortal}/assets/images/estimate_flow/icons/insurance.png`,
    },
    {
      id: 4,
      label: "Pest & Fire Control",
      img: `${config.customerPortal}/assets/images/estimate_flow/icons/pest-control.png`,
    },
  ];
  const JSX = (
    <>
      <Modal
        isOpen={props.isOpen}
        toggle={submitProgress === false ? props.toggle : () => { }}
        size={"lg"}
        className="pop-up-login-modal"
        centered={true}
      >
        <ModalHeader
          toggle={submitProgress === false ? props.toggle : () => { }}
          className="border-0 pop-up-header"
        ></ModalHeader>
        <ModalBody className="modal-body login pop-up-login p-0">
          <div className="container p-2">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                {" "}
                <div className="side-banner">
                  {props.serviceType === "storage" && (
                    <img
                      src={`${config.customerPortal}/assets/images/estimate_flow/storage_login_banner.jpg`}
                      alt="storage-img"
                      className="img-fluid"
                    />
                  )}
                  {props.serviceType === "relocation" && (
                    <img
                      src={`${config.customerPortal}/assets/images/estimate_flow/storage_login_banner.jpg`}
                      alt="relocation-img"
                      className="img-fluid"
                    />
                  )}
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                {/* Skip progress update */}
                {submitProgress === true && <SubmitProgress />}
                {submitProgress === false && error.status === false && (
                  <div className={`login-form ${isNewUser && "register-form"}`}>
                    <form
                      onSubmit={handleSubmit(onSubmit)}
                      id="loginForm"
                      autoComplete="off"
                    >
                      <h1
                        style={{
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                          marginBottom: "1.2rem",
                        }}
                      >
                        {/* {" "}
                  Customer <br /> Login{" "} */}
                        Enter your Mobile Number to continue
                      </h1>
                      <div style={{ fontSize: "1rem", marginBottom: "2rem" }}>
                        Never Shared, Never Spammed
                      </div>
                      <div
                        className={`form-group ${!isOTPsent && "full-grid"}`}
                      >
                        <input
                          type="text"
                          className={`form-control ${errors.phone && "error"}`}
                          name="phone"
                          id="phone"
                          defaultValue=""
                          readOnly={isOTPsent === true ? true : false}
                          ref={register({
                            required: true,
                            validate: {
                              numberOnly: (value) => {
                                return /^[0-9]*$/i.test(value);
                              },
                              phoneLength: (value) => {
                                return value.length === 10 ? true : false;
                              },
                            },
                          })}
                          placeholder="Mobile No"
                        />
                        {isOTPsent && (
                          <input
                            type="button"
                            className="btn"
                            // id="changeNumber"
                            onClick={() => {
                              setIsOTPsent(false);
                              setIsNewUser(false);
                              setStatusMessage("");
                            }}
                            value="Change"
                          />
                        )}

                        <span className="error-text phone-error">
                          {errors.phone &&
                            errors.phone.type === "required" &&
                            "Required."}
                          {errors.phone &&
                            errors.phone.type === "phoneLength" &&
                            "Please enter 10 digit phone."}
                          {errors.phone &&
                            errors.phone.type === "numberOnly" &&
                            "Please enter only numbers"}
                        </span>
                      </div>
                      {isOTPsent === true && isNewUser === false && (
                        <div className="form-group otp-container">
                          <input
                            type="text"
                            className={`form-control ${errors.otp && "error"}`}
                            name="otp"
                            ref={register({
                              required: true,
                              validate: {
                                numberOnly: (value) => {
                                  return /^[0-9]*$/i.test(value);
                                },
                                validOTPLength: (value) => {
                                  return value.length === 4 ? true : false;
                                },
                              },
                            })}
                            id="otp"
                            placeholder="Enter OTP"
                          />
                          <button
                            type="button"
                            id="resendOTP"
                            onClick={() => resendOTP()}
                            className={`btn timer text-center`}
                            disabled={timerStatus === true ? true : false}
                          >
                            {timerStatus === false &&
                              isOTPsent === true &&
                              "Resend OTP"}
                            {timerStatus === true && "0:" + timerCount}
                          </button>
                          <span className="error-text otp-error">
                            {errors.otp &&
                              errors.otp.type === "required" &&
                              "Required."}
                            {errors.otp &&
                              errors.otp.type === "validOTPLength" &&
                              "Please enter 4 digit OTP."}
                            {errors.otp &&
                              errors.otp.type === "numberOnly" &&
                              "Please enter only numbers"}
                          </span>
                        </div>
                      )}

                      {isNewUser === true && (
                        <div className="register-container">
                          <div className="form-group full-grid">
                            <input
                              type="text"
                              className={`form-control ${errors.fullName && "error"
                                }`}
                              id="fullName"
                              name="fullName"
                              ref={register({
                                required: true,
                                validate: {
                                  validName: (value) =>
                                    /^[a-z" ".]*$/i.test(value),
                                  maxLength: (value) =>
                                    value.length > 30 ? false : true,
                                },
                              })}
                              placeholder="Your Name"
                            />
                            <span className="error-text full_name-error">
                              {errors.fullName &&
                                errors.fullName.type === "required" &&
                                "Required."}
                              {errors.fullName &&
                                errors.fullName.type === "validName" &&
                                "Please enter only alphabets."}
                              {errors.fullName &&
                                errors.fullName.type === "maxLength" &&
                                "Maximum character allowed is 30."}
                            </span>
                          </div>
                          <div className="form-group full-grid">
                            <input
                              type="text"
                              className={`form-control ${errors.email && "error"
                                }`}
                              id="email"
                              name="email"
                              ref={register({
                                required: true,
                                email: true,
                                validate: {
                                  validEmail: (value) => {
                                    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                                      value
                                    );
                                  },
                                  maxLength: (value) =>
                                    value.length > 40 ? false : true,
                                },
                              })}
                              placeholder="Email Id"
                            />
                            <span className="error-text email-error">
                              {errors.email &&
                                errors.email.type === "required" &&
                                "Required."}
                              {errors.email &&
                                errors.email.type === "validEmail" &&
                                "Please enter a valid email."}
                              {errors.email &&
                                errors.email.type === "maxLength" &&
                                "Maximum character allowed is 40."}
                            </span>
                            {/* <div className="terms-and-conditions">
                              By signing up I accept to the{" "}
                              <a
                                href={
                                  BOXIGO_WEBSITE_LINKS.customer_terms_and_conditions_page
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {" "}
                                terms &amp; conditions{" "}
                              </a>{" "}
                              and
                              <a
                                href={
                                  BOXIGO_WEBSITE_LINKS.customer_privacy_policy_page
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {" "}
                                privacy policy{" "}
                              </a>{" "}
                              of Boxigo
                            </div> */}
                          </div>
                        </div>
                      )}
                      <div className="login-btn-container">
                        <div>
                          {isOTPsent === false && isNewUser === false && (
                            <button className="btn" id="sendOTP" type="submit">
                              {" "}
                              Continue{" "}
                            </button>
                          )}
                          {isOTPsent === true && isNewUser === false && (
                            <button
                              type="submit"
                              className="btn mt-0 login-btn"
                              id="confirmOTP"
                            >
                              Login
                            </button>
                          )}
                        </div>
                      </div>
                      {isNewUser === true && (
                        <div className="register-submit-container">
                          <input
                            type="submit"
                            className="btn mt-0"
                            id="registerCustomer"
                            value="Register"
                          />
                          <div className="sub-info">
                            {/* <p className="text-center mt-3">
                              You will not receive any spam calls or third party
                              calls{" "}
                            </p> */}
                          </div>
                        </div>
                      )}
                      {statusMessage !== "" && (
                        <div className="my-2">
                          <div id="msg" className="d-inline">
                            {" "}
                            {statusMessage}{" "}
                          </div>
                        </div>
                      )}
                    </form>
                  </div>
                )}
                {submitProgress === false && error.status === true && (
                  <ErrorMessage
                    error={error}
                    updateError={(data) => {
                      props.toggle();
                    }}
                  />
                )}
                <hr />
                <div className="featured-services">
                  <h3 className="heading">Why Choose Boxigo Services?</h3>
                  <div className="row services-list">
                    {props.serviceType === "relocation" &&
                      relocationServicesList.map((list) => {
                        return (
                          <>
                            <div key={list.id} className="col-sm-6">
                              <div className="service-info">
                                <img src={list.img} alt="" className="icon" />
                                <span className="ml-1">{list.label}</span>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    {props.serviceType === "storage" &&
                      storageServicesList.map((list) => {
                        return (
                          <>
                            <div key={list.id} className="col-sm-6">
                              <div className="service-info">
                                <img src={list.img} alt="" className="icon" />
                                <span className="ml-1">{list.label}</span>
                              </div>
                            </div>
                          </>
                        );
                      })}
                  </div>
                  <div className="terms-and-conditions">
                    By signing up I accept to the{" "}
                    <a
                      href={
                        BOXIGO_WEBSITE_LINKS.customer_terms_and_conditions_page
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      terms &amp; conditions{" "}
                    </a>{" "}
                    and
                    <a
                      href={BOXIGO_WEBSITE_LINKS.customer_privacy_policy_page}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      privacy policy{" "}
                    </a>{" "}
                    of Boxigo
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
  return JSX;
}

export function SubmitProgress() {
  const JSX = (
    <div className="submit-estimate-progress-container p-5">
      <div className="d-flex align-items-center justify-content-center">
        <Spinner />
        <div className="mx-2"> Submitting Information... </div>
      </div>
    </div>
  );
  return JSX;
}

export function ErrorMessage(props) {
  const { error, updateError } = props;
  const JSX = (
    <div className="submit-estimate-progress-container p-5">
      <div className="d-flex flex-column align-items-center justify-content-center">
        <div className="mx-2 my-3"> {error.message} </div>
        <div>
          <button
            className="btn btn-dark"
            onClick={() => {
              updateError({ status: false, message: "" });
            }}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
  return JSX;
}
